import React from 'react'
import { Header, List, Grid, Segment } from 'semantic-ui-react'

export default function ListarEventos({ eventos, funcionarios, form }) {

    function findEvent(dados) {
        if (eventos && eventos.find((event) => event.codigo === dados.codigo)) {
            return (
                eventos.filter((event) => event.codigo === dados.codigo)
                    .map((event, idx) => (
                        <React.Fragment key={idx}>
                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <List divided>
                                        {event.inputs.filter((inputs, index) => index <= 6).map((inputs, index) => (
                                            <List.Item key={index}>
                                                <Header floated='left' style={{ fontSize: '15px' }}>
                                                    {inputs.id} - {inputs.descricao}
                                                </Header>
                                                <Header floated='right' style={{ fontSize: '15px' }}>
                                                    {inputs.valor}
                                                </Header>
                                            </List.Item>
                                        ))}
                                    </List>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <List divided>
                                        {event.inputs.filter((inputs, index) => index > 6).map((inputs, index) => (
                                            <List.Item key={index}>
                                                <Header floated='left' style={{ fontSize: '15px' }}>
                                                    {inputs.id} - {inputs.descricao}
                                                </Header>
                                                <Header floated='right' style={{ fontSize: '15px' }}>
                                                    {inputs.valor}
                                                </Header>
                                            </List.Item>
                                        ))}
                                    </List>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row style={{ backgroundColor: '#f7f7f7' }}>
                                <Grid.Column>
                                    <Header style={{ fontSize: '15px', color: '#263f6e' }}>
                                        Observação: {event.observacao}
                                    </Header>
                                </Grid.Column>
                            </Grid.Row>
                        </React.Fragment>
                    ))
            )
        } else {
            return (
                <React.Fragment>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment basic>
                                <Header textAlign='center' color='red'>
                                    Dados inexistentes
                                </Header>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </React.Fragment>
            )
        }
    }

    const funcionariosList = funcionarios.filter((dados) => dados.id_empresa === form.empresa)
        .map((dados, index) => (
            <List.Item key={index}>
                <Grid celled style={{ margin: '0px', marginBottom: '5px' }}>
                    <Grid.Row>
                        <Grid.Column width={16} style={{ backgroundColor: '#f7f7f7' }}>
                            <Header floated='left' style={{ fontSize: '16px' }}>
                                Funcionário: {dados.nome}
                                <Header.Subheader style={{ color: 'grey' }}>
                                    Código: {dados.codigo}
                                </Header.Subheader>
                            </Header>
                            <Header floated='right' color='grey' style={{ fontSize: '16px' }}>
                                {dados.cargo}
                            </Header>
                        </Grid.Column>
                    </Grid.Row>
                    {findEvent(dados)}
                </Grid>
            </List.Item >
        ))

    return (
        <List style={{ marginBottom: '20px' }}>
            {funcionariosList}
        </List>
    )

}